export default class StocksGestionRapportActiviteSaveController {
	static $inject = [
		'$scope',
		'$state',
		'$uibModal',
		'notification',
		'$translate',
		'$filter',
		'moment',
		'StocksGestionRapportActiviteService',
		'MassiaRightsService',
		'$location',
		'_'
	];

	constructor(
		$scope,
		$state,
		$uibModal,
		notification,
		$translate,
		$filter,
		moment,
		StocksGestionRapportActiviteService,
		MassiaRightsService,
		$location,
		_
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModal = $uibModal;
		this.notification = notification;
		this.$translate = $translate;
		this.$filter = $filter;
		this.moment = moment;
		this.StocksGestionRapportActiviteService = StocksGestionRapportActiviteService;
		this.MassiaRightsService = MassiaRightsService;
		this.$location = $location;
		this._ = _;
		this.produits = [];
		this.produitsCibles = [];
		this.titleButton = 'Valider';
	}

	async $onInit() {
		this.iterator = 0;
		this.nbProduit = this.data.idProduits.length;
		this.motifs = await this.StocksGestionRapportActiviteService.getMotifs();
		const idProduitSite = this.data.idProduits[this.iterator];
		const [idProduit, idProducteur] = idProduitSite.split('_');
		await this.loadProduits(idProduit, idProducteur);
		await this.initProduit(idProduit, idProducteur);
		await this.getElementsSelectionnables();
	}

	async initProduit(idProduit, idProducteur) {
		this.productionDisplay = this.data.newProductionDisplays.find((x) => x.idProduit == idProduit && x.idSiteProducteur == idProducteur);
		this.transfertDisplay = this.data.newTransferts.find((x) => x.idProduit == idProduit && x.idSiteProducteur == idProducteur);
		this.ajustementDisplay = this.data.newAjustements.find((x) => x.idProduit == idProduit && x.idSiteProducteur == idProducteur);

		let titleProduit = this.ajustementDisplay?.libelleProduit ?? this.transfertDisplay?.libelleProduit ?? this.productionDisplay.libelleProduit;

		const ttt = this.iterator + 1;
		this.etape = ttt + '/' + this.nbProduit;
		this.titleDisplay = `Confirmation ${this.etape} - ${titleProduit}`;
		this.titleButton = `Valider et Continuer ${this.etape}`;
		if (ttt == this.nbProduit) {
			this.titleButton = `Valider ${this.etape}`;
		}

		if (typeof this.ajustementDisplay !== 'undefined' && this.motifs != null && this.motifs.length > 0) {
			this.ajustementDisplay.idMotifAjustement = this.motifs[0].id;
		}

		if (
			this.transfertDisplay &&
			this.transfertDisplay.mouvementsTransfertCible &&
			Array.isArray(this.transfertDisplay.mouvementsTransfertCible) &&
			this.transfertDisplay.mouvementsTransfertCible.length > 0
		) {
			//on regroupe les mouvements par idProduit et idSiteProducteur
			const groupedProduitProducteurList = this.transfertDisplay.mouvementsTransfertCible.reduce((acc, mouv) => {
				const key = `${mouv.idProduit}_${mouv.idSiteProducteur}`;

				if (!acc[key]) {
					acc[key] = [
						{
							id: mouv.id,
							idTransfertOrigin: mouv.idTransfertOrigin,
							idProduit: mouv.idProduit,
							idSiteProducteur: mouv.idSiteProducteur,
							quantite: mouv.quantite,
							mouvement: mouv.mouvement
						}
					];
				} else {
					acc[key].push({
						id: mouv.id,
						idTransfertOrigin: mouv.idTransfertOrigin,
						idProduit: mouv.idProduit,
						idSiteProducteur: mouv.idSiteProducteur,
						quantite: mouv.quantite,
						mouvement: mouv.mouvement
					});
				}

				return acc;
			}, {});

			//pour chaque clé dans groupedProduitProducteurList
			for (const key in groupedProduitProducteurList) {
				if (Object.prototype.hasOwnProperty.call(groupedProduitProducteurList, key)) {
					const groupedProduitProducteur = groupedProduitProducteurList[key];
					const produit = this.produits.find(
						(p) =>
							p.idProduit === groupedProduitProducteur[0].idProduit && p.idProducteur === groupedProduitProducteur[0].idSiteProducteur
					);

					this.produitsCibles.push({
						idTransfertOrigin: groupedProduitProducteur[0].idTransfertOrigin,
						idMouvementTransfert: groupedProduitProducteur.find((x) => x.mouvement === 6)?.id || 0,
						idMouvementProduction: groupedProduitProducteur.find((x) => x.mouvement === 3)?.id || 0,
						idProduit: groupedProduitProducteur[0].idProduit,
						codeProduit: produit?.codeProduit || '',
						libelleProduit: produit?.libelleProduit || '',
						isCible: true,
						idProducteur: groupedProduitProducteur[0].idSiteProducteur,
						siteProducteur: produit?.siteProducteur || '',
						quantitePourTransfert: groupedProduitProducteur.find((x) => x.mouvement === 6)?.quantite || 0,
						quantitePourProduction: groupedProduitProducteur.find((x) => x.mouvement === 3)?.quantite || 0
					});
				}
			}
			this.totalProduitsCible();
		}
	}

	async loadProduits(idProduit, idProducteur) {
		//TODO : Ajouter la notion de idMouvementTransfertOrigine
		this.startLoading();
		try {
			this.produits = await this.StocksGestionRapportActiviteService.getProduitsByGroupeSite(this.data.idGroupeSite, idProduit, idProducteur);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	totalProduitsCible() {
		if (this.produitsCibles.findIndex((p) => p.quantitePourTransfert < 0 || p.quantitePourProduction < 0) != -1) {
			const total = 'Une quantité est négative';
			const alert = true;
			const difference = 0;
			const differenceTrad = '';
			this.totalCible = { total, alert, difference, differenceTrad };
		} else {
			const totalPourTransfert = this.produitsCibles.reduce((acc, x) => acc + x.quantitePourTransfert, 0);
			const totalPourProduction = this.produitsCibles.reduce((acc, x) => acc + x.quantitePourProduction, 0);
			let total = totalPourTransfert + totalPourProduction;
			const difference = (total - this.transfertDisplay.quantite * -1) * -1;
			const differenceTrad = difference > 0 ? 'MANQUE' : 'EN_TROP';
			if (total.toString().includes('NaN')) total = 'Une quantité est invalide';
			const alert = total !== this.transfertDisplay.quantite * -1;
			this.totalCible = { total, alert, difference, differenceTrad };
		}
	}

	async changeProduit() {
		if (this.transfertDisplay && this.produitsCibles.length == 0) {
			this.notification.error('Produit manquant.');
			return;
		}
		if (this.transfertDisplay) {
			if (this.totalCible.alert) {
				const quantiteSource = this.transfertDisplay.quantite * -1;
				this.notification.error('La quantité de la répartition doit être égale à ' + quantiteSource);
				return;
			}
			// on ajoute les produits cibles qui ont une quantité de transfert
			this.transfertDisplay.mouvementsTransfertCible = this.produitsCibles
				.filter((x) => x.quantitePourTransfert > 0)
				.map((x) => ({
					id: x.idMouvementTransfert,
					idProduit: x.idProduit,
					idSiteProducteur: x.idProducteur,
					mouvement: 6,
					quantite: x.quantitePourTransfert
				}));

			// on ajoute les produits cibles qui ont une quantité de production
			const toProd = this.produitsCibles
				.filter((x) => x.quantitePourProduction > 0)
				.map((x) => ({
					id: x.idMouvementProduction,
					idProduit: x.idProduit,
					idSiteProducteur: x.idProducteur,
					mouvement: 3,
					quantite: x.quantitePourProduction,
					isFromTransferProcess: true
				}));
			if (toProd.length > 0) {
				this.data.newProductions.push(...toProd);
			}
		}
		this.iterator = this.iterator + 1;
		if (this.iterator < this.nbProduit) {
			const idProduitSite = this.data.idProduits[this.iterator];
			const [idProduit, idProducteur] = idProduitSite.split('_');

			await this.initProduit(idProduit, idProducteur);
			await this.getElementsSelectionnables();
			if (this.transfertDisplay) {
				for (var index = 0; index < this.produitSelect.length; index++) {
					this.produitSelect[index].valeur = false;
				}
				this.composant = [];
				this.produitsCibles = [];
			}
		} else {
			await this.saveMouvements();
			this.annuler();
		}
	}
	annuler() {
		this.modalInstance.close();
	}

	async saveMouvements() {
		this.data.newProductionDisplays = null;
		await this.StocksGestionRapportActiviteService.updateGestionRapport(this.data);
	}

	async getElementsSelectionnables() {
		if (this.transfertDisplay) {
			try {
				if (typeof this.produitSelect == 'undefined') {
					let indexToDelete = [];
					let allProduits = angular.copy(this.produits);
					//si on edit le transfert, on doit enlever les produits déjà sélectionnés
					if (this.produitsCibles.length > 0) {
						allProduits = allProduits.filter(
							(x) =>
								!this.produitsCibles.some(
									(y) =>
										(y.idMouvementTransfert !== null || y.idMouvementTransfert !== null) &&
										x.idProduit === y.idProduit &&
										x.idProducteur === y.idProducteur
								)
						);
					}
					for (var i = 0; i < allProduits.length; i++) {
						let currentValue = allProduits[i];
						if (
							currentValue.idProduit == this.transfertDisplay.idProduit &&
							currentValue.idProducteur == this.transfertDisplay.idProducteur
						) {
							indexToDelete.push(i);
						}
						if (currentValue.isCible) {
							//Si le produit est déjà dans les produits cibles (car précédent transfert) on l'ajoute pas à nouveau
							const existIndex = this.produitsCibles.findIndex(
								(p) =>
									p.codeProduit == currentValue.codeProduit &&
									(p.idProducteur == null || p.idProducteur == currentValue.idProducteur)
							);
							if (existIndex == -1) {
								indexToDelete.push(i);
								this.produitsCibles.push({ ...currentValue, quantitePourTransfert: 0, quantitePourProduction: 0 });
							}
						}
					}
					for (var j = indexToDelete.length - 1; j >= 0; j--) {
						allProduits.splice(indexToDelete[j], 1);
					}

					// Distinct par produit / producteur
					const result = allProduits.reduce((prev, el) => {
						if (prev.some((o) => o.idProducteur == el.idProducteur && o.idProduit == el.idProduit)) return prev;
						return [...prev, el];
					}, []);

					this.produitSelect = await this.prepareListeElementsLies(result);
				}
			} catch (err) {
				if (err.data) this.notification.error(err.data);
				else throw err;
			}
		}
	}

	async prepareListeElementsLies(elementsATraiter) {
		var elementsSelectionnablesOrdonnes = this.$filter('orderBy')(elementsATraiter, 'siteProducteur');
		var tmp = null;
		var temp = [];
		for (var index = 0; index < elementsSelectionnablesOrdonnes.length; index++) {
			var currentValue = elementsSelectionnablesOrdonnes[index];
			var toReturn = [];

			if (Object.prototype.hasOwnProperty.call(currentValue, 'modeDeclenchement')) {
				currentValue.idComposant = currentValue.id;
				toReturn.push(currentValue);
			} else {
				if (tmp == null) {
					//creation du premier groupe
					tmp = currentValue.idProducteur;
					toReturn.push({
						libelle: '<span="font-weight:bold">' + currentValue.siteProducteur + '</span>',
						msGroup: true
					});
				} else {
					if (tmp != currentValue.idProducteur) {
						//création des autres groupes
						toReturn.push({ msGroup: false });
						tmp = currentValue.idProducteur;
						toReturn.push({
							libelle: '<span="font-weight:bold">' + currentValue.siteProducteur + '</span>',
							msGroup: true
						});
					}
				}
				currentValue.libelle = currentValue.codeProduit + ' - ' + currentValue.libelleProduit;
				currentValue.valeur = false;
				currentValue.idComposant = currentValue.idProduit;
				currentValue.code = currentValue.codeProduit;
				toReturn.push(currentValue);

				if (index == elementsSelectionnablesOrdonnes.length - 1) {
					toReturn.push({ msGroup: false });
				}
			}
			temp.push(toReturn);
		}
		var sorties = this._.flatten(temp);
		return new Promise((resolve) => resolve(sorties));
	}

	addComposant() {
		this.produitsCibles.push({ ...this.composant[0], quantitePourTransfert: 0, quantitePourProduction: 0 });
		const index = this.produitSelect.findIndex(
			(x) => x.idProduit == this.composant[0].idProduit && x.idProducteur == this.composant[0].idProducteur
		);

		this.produitSelect.splice(index, 1);
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
